import { useEffect, useState } from "react";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import { toast } from "react-toastify";
import { useAddCustomerTag, useUpdateCustomerTag } from "../hooks/useCustomerTag";
import { showToast } from "../../../../utils/toastUtils";

type ModalProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    rowData?: any;

};
const CustomerTagAddAndEditModal: React.FC<ModalProps> = ({ rowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const [modalValues, setModalValues] = useState<any>({
        outletTagName: '',
    })
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { mutate,isPending:isadd } = useAddCustomerTag();
    const { mutate: updateMutate,isPending:isPending } = useUpdateCustomerTag();

    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, outletTagName: '' }))
    }


const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent multiple clicks
    setIsSubmitting(true);

    if (!modalValues?.outletTagName) {
        showToast.warning("Please enter Customer tag.");
        setIsSubmitting(false);
        return;
    }

    const body: any = {
        outletTagName: modalValues?.outletTagName,
    };

    const onSuccessHandler = () => {
        handleClose();
        setIsSubmitting(false);
    }

    if (checkAddEditStatus === "Add") {
        mutate(body, { onSuccess: onSuccessHandler, onError: () => setIsSubmitting(false) });
    } else {
        body['outletTagId'] = rowData?.OutletTagId;
        updateMutate({ body }, { onSuccess: onSuccessHandler, onError: () => setIsSubmitting(false) });
    }
};





    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            // console.log('rowDataaaaaaaaa',rowData)
            setModalValues((prevState: any) => ({ ...prevState, outletTagName: rowData?.TagName }))
        }
    }, [checkAddEditStatus])


    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen); setModalValues((prevState: any) => ({ ...prevState, outletTagName: '' })); }}
            title={title}
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0 col-sm-12">
                        <CustomInput
                            placeholder="Customer Tag"
                            disabled={false}
                            onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, outletTagName: e.target.value })); }}
                            value={modalValues?.outletTagName}
                            
                            label="Customer Tag*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />

                        {/* Buttons */}
                        <div className="d-flex justify-content-start gap-2">
                           <Btn
  style={{ backgroundColor: "#43B9B2", color: "white" }}
  type="submit"
  disabled={isadd || isPending || isSubmitting}
>
  {isadd || isPending || isSubmitting
    ? checkAddEditStatus === 'Add'
      ? 'Submitting...'
      : 'Updating...'
    : checkAddEditStatus === 'Add'
    ? 'Submit'
    : 'Update'}
</Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, outletTagName: '' })); }}
                            >
                                Cancel
                            </Btn>
                        </div>
                    </div>
                </form>
            }
        />
    )
}

export default CustomerTagAddAndEditModal;